import useNavigateToMainPage from 'utils/hooks/useNavigateToMainPage';
import { useSupersetDashboard } from 'hooks/useSupersetDashboard';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { selectors as authSelectors } from 'state/auth';
import { useTranslation } from 'react-i18next';
// styles
import styled from 'styled-components';
//components
import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';
import { userIsAuthenticatedRedir } from 'components/auth/hoc';
import Tabs from 'refactored/ui/nav/appBar/tabs';
import EmptyListPage from 'components/EmptyListPage';

export const DASHBOARD_TYPES = {
  sustainability: 'sustainability',
  analytics: 'analytics',
};

const TabedPageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow: auto;
  flex-direction: column;
`;

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid var(--grey200);
`;

const Container = styled.div`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  margin: 1rem 1rem 0rem;
`;

const Iframe = styled.iframe`
  flex-grow: 1;
  border: 0;
`;

const EmptyListPageStyled = styled(EmptyListPage)`
  height: 50%;
`;

const Analytics = ({ hasViewAuth }) => {
  const dashboardAnalyticsUrl = useSupersetDashboard(DASHBOARD_TYPES.analytics);

  return (
    <>
      {hasViewAuth && (
        <Iframe
          title="Analytics dashboard"
          width="100%"
          height="100%"
          src={dashboardAnalyticsUrl}
        />
      )}
      {!hasViewAuth && <EmptyListPageStyled page="analytics" />}
    </>
  );
};

const Sustainability = () => {
  const dashboardSustainabilityUrl = useSupersetDashboard(
    DASHBOARD_TYPES.sustainability
  );
  return (
    <Iframe
      title="Sustainability dashboard"
      width="100%"
      height="100%"
      src={dashboardSustainabilityUrl}
    />
  );
};

const DashboardPage = () => {
  const { t } = useTranslation('Dashboard');
  const pathname = useSelector((state) => state.router.location.pathname);
  const handleBack = useNavigateToMainPage();
  const dispatch = useDispatch();

  const permissions = useSelector(authSelectors.getUserPermissions) || [];
  const hasViewAuth = permissions.includes('core.view_analytics');

  const analytisRoute = '/dashboard/analytics';
  const sustainabilityRoute = '/dashboard/sustainability';
  if (pathname === '/dashboard' && !hasViewAuth) {
    dispatch(push(sustainabilityRoute));
  } else if (pathname === '/dashboard' && hasViewAuth) {
    dispatch(push(analytisRoute));
  }

  const options = [
    {
      label: t('analytics'),
      value: analytisRoute,
      onClick: () => dispatch(push(analytisRoute)),
    },
    {
      label: t('sustainability'),
      value: sustainabilityRoute,
      onClick: () => dispatch(push(sustainabilityRoute)),
    },
  ];

  return (
    <AuthenticatedUserView handleBack={handleBack}>
      <TabedPageContainer>
        <StyledTabs value={pathname} options={options} />
        <Container>
          {pathname === analytisRoute && (
            <Analytics hasViewAuth={hasViewAuth} />
          )}
          {pathname === sustainabilityRoute && <Sustainability />}
        </Container>
      </TabedPageContainer>
    </AuthenticatedUserView>
  );
};

export default userIsAuthenticatedRedir(DashboardPage);
